// extracted by mini-css-extract-plugin
export default {"FooterSection":"FooterSection_FooterSection__Y4TzY","Stack":"FooterSection_Stack__pd0W7","MapImage":"FooterSection_MapImage__YgytC"};